import { createValidation } from '../../utils/validation';
// Field validation only; tracking display names are configured in contractCategoryConfig.trackingSection.
import contractCategoryConfig from './contractCategoryConfig';

const createContractCategoryValidation = () => {
  return createValidation(contractCategoryConfig.fields);
};

export const validateContractCategoryData = createContractCategoryValidation();
export const createContractCategoryValidationSchema = createContractCategoryValidation;
export default createContractCategoryValidation;
